module.exports = __webpack_public_path__ + "img/resultado-municipal-2026-q2.45165c52.png";